<template>
  <v-content class="grey lighten-2">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-content>
</template>

<script>
export default {}
</script>

<style scoped></style>
